<template>
  <span class="text-start d-inline-flex align-center">
    <country-flag :country="itemCountry" :size="size" style="margin: -15px"/>  <span> {{itemLabel}} </span>
  </span>
</template>

<script>
import CountryFlag from 'vue-country-flag'

export default {
  name: 'BaseLabelWithFlag',
  components: { CountryFlag },
  props: {
    itemCountry: {
      type: String,
      required: true
    },
    itemLabel: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'normal'
    }
  }
}
</script>

<style scoped>
.normal-flag {
    margin: -15px;
}

</style>
